import { Pipe, PipeTransform } from "@angular/core";
import { convertTimeStringToSeconds, getFormattedTimeString } from "../shared/date-and-time-format";
import { REGEX_TIMESTRING_HH_MM_SS, REGEX_TIMESTRING_HHHH_MM_SS, REGEX_TIMESTRING_MM_SS_T } from "../constants/CommonRegex";

@Pipe({
  name: "formatTimeString",
})
export class TimeStringPipe implements PipeTransform {
  transform(value: string) {
    if(value.match(REGEX_TIMESTRING_HHHH_MM_SS) || value.match(REGEX_TIMESTRING_MM_SS_T))
    {
      var totalSeconds = convertTimeStringToSeconds(value);
      return getFormattedTimeString(totalSeconds);
    }

    return value;
  }
}